import React from 'react';
import styled from 'styled-components';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { textSize, Points, marginLevel } from '@styles';
import { BlogCards, BlogCardsContainer } from '@components/Blog-Cards';
import { useTranslations } from '@libs/translations';

export const BlogPopular = ({ articles = [] }) => {
  const translations = useTranslations();

  return (
    <Container>
      <Wrapper>
        <Content>
          <Title>{translations.t('site.blog.popular')}</Title>
          <BlogCards cards={articles} />
        </Content>
      </Wrapper>
    </Container>
  );
};

const Container = styled.section`
  padding-top: 12vw;
  padding-bottom: 12vw;

  @media ${Points.laptop} {
    padding-top: 7vw;
  }

  ${BlogCardsContainer} {
    ${Grid.suffix(2)};
    ${Grid.prefix(2)};
  }
`;

const Wrapper = styled.div`
  position: relative;
  background-color: ${Colors.white};
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1440px;
  margin: 0 auto;

  @media ${Points.mobile_only} {
    article:nth-child(n + 4) {
      display: none;
    }
  }

  @media ${Points.tablet_portrait} {
    article:nth-child(n + 5) {
      display: none;
    }
  }

  @media ${Points.laptop} {
    article:nth-child(n + 5) {
      display: block;
    }
  }
`;

const Title = styled.h2`
  ${Grid.push(2)};
  ${textSize('h2')};
  ${marginLevel('bottom', 'dark_cream')};
  position: relative;
  z-index: 1;
`;
